import { v4 as uuidv4 } from 'uuid';

import { Login } from '../../../../vtex-apps/login/Login/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { DrawerCloseButton } from '../../../../vtex-apps/store-drawer/DrawerCloseButton/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Logo } from '../../../../vtex-apps/store-components/Logo/default';
import { SearchBar } from '../../../../vtex-apps/store-components/SearchBar/default';
import { Drawer } from '../../../../vtex-apps/store-drawer/Drawer/default';
import { DrawerHeader } from '../../../../vtex-apps/store-drawer/DrawerHeader/default';
import { StickyLayout } from '../../../../vtex-apps/sticky-layout/StickyLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';

const HeaderMobile = () => {
	return {
		componentName: 'HeaderMobile',
		componentId: uuidv4(),
		componentGroup: 'HeaderMobile',
		props: {
			mzTitle: 'MZ | Header - Mobile',
		},
		variables,
		childrenComponents: [
			StickyLayout(
				{
					blockClass: 'header-mob-2__sticky',
					position: 'top',
					verticalSpacing: 0,
				},
				[
					VisibilityLayout({ mzTitle: 'MZ | Topbar (On/Off)' }, [
						FlexLayoutRow(
							{
								mzTitle: 'MZ | Topbar',
								blockClass: 'header-mob-2__topbar-row',
								preserveLayoutOnMobile: true,
								paddingTop: 2,
								paddingBottom: 2,
							},
							[
								SliderLayout(
									{
										blockClass: 'header-mob-2__topbar-slider',
										showNavigationArrows: 'always',
										showPaginationDots: 'never',
										autoplay: {
											timeout: 5000,
										},
										arrowSize: 14,
									},
									[
										VisibilityLayout({ mzTitle: 'MZ | Slide 1 (On/Off)' }, [
											FlexLayoutRow(
												{
													blockClass: 'header-mob-2__slider-row',
													preserveLayoutOnMobile: true,
												},
												[
													Image({
														blockClass: 'header-mob-2__topbar-image',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
													}),
													RichText({
														text: 'Entrega em todo o Brasil',
														blockClass: 'header-mob-2__topbar-slider-text',
													}),
												],
											),
										]),
										VisibilityLayout({ mzTitle: 'MZ | Slide 2 (On/Off)' }, [
											FlexLayoutRow(
												{
													blockClass: 'header-mob-2__slider-row',
													preserveLayoutOnMobile: true,
												},
												[
													Image({
														blockClass: 'header-mob-2__topbar-image',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
													}),
													RichText({
														text: 'Entrega em todo o Brasil',
														blockClass: 'header-mob-2__topbar-slider-text',
													}),
												],
											),
										]),
										VisibilityLayout({ mzTitle: 'MZ | Slide 3 (On/Off)' }, [
											FlexLayoutRow(
												{
													blockClass: 'header-mob-2__slider-row',
													preserveLayoutOnMobile: true,
												},
												[
													Image({
														blockClass: 'header-mob-2__topbar-image',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
													}),
													RichText({
														text: 'Entrega em todo o Brasil',
														blockClass: 'header-mob-2__topbar-slider-text',
													}),
												],
											),
										]),
										VisibilityLayout({ mzTitle: 'MZ | Slide 4 (On/Off)' }, [
											FlexLayoutRow(
												{
													blockClass: 'header-mob-2__slider-row',
													preserveLayoutOnMobile: true,
												},
												[
													Image({
														blockClass: 'header-mob-2__topbar-image',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
													}),
													RichText({
														text: 'Entrega em todo o Brasil',
														blockClass: 'header-mob-2__topbar-slider-text',
													}),
												],
											),
										]),
										VisibilityLayout({ mzTitle: 'MZ | Slide 5 (On/Off)' }, [
											FlexLayoutRow(
												{
													blockClass: 'header-mob-2__slider-row',
													preserveLayoutOnMobile: true,
												},
												[
													Image({
														blockClass: 'header-mob-2__topbar-image',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1682365252437-1682365097262-mz-icon-pix---37417b16296b4eb32c640ad03719aa1f.png',
													}),
													RichText({
														text: 'Entrega em todo o Brasil',
														blockClass: 'header-mob-2__topbar-slider-text',
													}),
												],
											),
										]),
									],
								),
							],
						),
					]),
					FlexLayoutRow(
						{ colSizing: 'auto', blockClass: 'header-mob-2__row-container', preserveLayoutOnMobile: true },
						[
							Drawer(
								{ blockClass: 'header-mob-2__drawer', slideDirection: 'horizontal' },
								[
									DrawerHeader({ blockClass: 'header-mob-2__drawer-header' }, [
										DrawerCloseButton({ blockClass: 'header-mob-2__drawer' }),
									]),
								],
								[
									FlexLayoutRow(
										{
											colSizing: 'auto',
											blockClass: 'header-mob-2__row-login',
											fullWidth: true,
											preserveLayoutOnMobile: true,
										},
										[
											FlexLayoutCol({ blockClass: 'header-mob-2__col-login' }, [
												Login({
													iconLabel: 'Minha conta',
													blockClass: 'header-mob-2__login',
													accountOptionsButtonBehavior: 'link',
												}),
											]),
											FlexLayoutCol({ blockClass: 'header-mob-2__col-favoritos' }, [
												RichText({
													text: 'Meus **favoritos**',
													blockClass: 'mz-header-2-mobile__favoritos-text',
												}),
											]),
										],
									),

									FlexLayoutRow({ colSizing: 'auto', blockClass: 'header-mob-2__search-row', fullWidth: true }, [
										FlexLayoutCol({ blockClass: 'header-mob-2__search-col' }, [
											SearchBar({ blockClass: 'header-mob-2__search-bar' }),
										]),
									]),
									{
										componentGroup: 'StoreMenuMobile',
										componentName: 'Menu',
										componentId: uuidv4(),
									},
									FlexLayoutRow(
										{
											blockClass: 'header-mob-2__links-row',
											fullWidth: true,
											preserveLayoutOnMobile: true,
											horizontalAlign: 'right',
										},
										[
											FlexLayoutCol({ blockClass: 'header-mob-2__links-col' }, [
												RichText({
													text: '**Dúvidas?**',
													blockClass: 'header-mob-2__link--header',
												}),
												RichText({
													text: 'Fale com a gente por WhatsApp',
													blockClass: 'header-mob-2__link',
												}),
												RichText({
													text: 'Envie seu contato para a gente',
													blockClass: 'header-mob-2__link',
												}),
												RichText({
													text: 'Atendimento: de Segunda a Sexta-feira das 09:00 às 18:00 e Sábado das 08:00 às 13:00',
													blockClass: 'header-mob-2__link',
												}),
											]),
										],
									),
								],
							),
							Logo({
								url: 'https://maeztra.com/wp-content/uploads/2020/09/logo_Prancheta-1.svg',
								href: '/',
								height: 30,
								blockClass: 'header-mob-2__logo',
							}),
							FlexLayoutRow(
								{
									blockClass: 'header-mob-2__row-icons',
									preserveLayoutOnMobile: true,
									horizontalAlign: 'right',
									colSizing: 'auto',
								},
								[
									Login({
										iconLabel: '',
										blockClass: 'header-mob-2__icon-login',
									}),
									RichText({
										text: '[Favoritos](/wishlist)',
										blockClass: 'header-mob-2__icon-favoritos',
									}),
									{
										componentGroup: 'MinicartGroup',
										componentName: 'MinicartGroup',
										componentId: uuidv4(),
									},
								],
							),
						],
					),
				],
			),
			// VisibilityLayout({visible:true,mzTitle:"Modal de cookies"},[{componentName:"CookieModal"}]),
			VisibilityLayout({ mzTitle: 'MZ | Botão Whatsapp (On/Off)' }, [
				FlexLayoutRow({ blockClass: 'mz-header-mob-2-whats-float__flex-row', preserveLayoutOnMobile: true }, [
					Image({
						blockClass: 'whatsapp-float-mob-2__image',
						src: 'https://hefesto-upload-images.s3.amazonaws.com/1682006713447-1681501967650-WhatsApp.png',
					}),
					RichText({ blockClass: 'whatsapp-float-mob-2__text', text: '[Atendimento](https://whts.co/)' }),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--header-mobile-2-bg-color', name: 'Header Background' },
			{ from: '--white', to: '--header-mobile-2-drawer-bg-color', name: 'Drawer Background' },
			{ from: '--white', to: '--header-mobile-2-dr-head-bg-color', name: 'Drawer Header' },
			{ from: '--text-color-1', to: '--header-mobile-2-dr-head-text-color', name: 'Drawer Header Text' },
			{ from: '--text-color-1', to: '--header-mobile-2-text-color', name: 'Icons' },
			{ from: '--text-color-1', to: '--header-mobile-2-links-color', name: 'Links Text' },
			{ from: '--text-color-1', to: '--header-mobile-2-search-border-color', name: 'Search Border' },
			// { from: "--text-color-1-dark", to: "--header-mobile-2-search-button-color", name: "Search Button Color" },
			{ from: '--black', to: '--header-mobile-2-search-button-icon', name: 'Search Button Icon' },
			//minicart color
			{ from: '--support-color-3', to: '--header-mobile-2-minicart-color', name: 'Minicart' },
			{ from: '--white', to: '--header-mobile-2-minicart-text', name: 'Minicart Text' },
			{ from: '--support-color-3', to: '--header-mobile-2-whatsapp-bg-color', name: 'Whatsapp Background' },
			{ from: '--support-color-3', to: '--header-mobile-2-whatsapp-bg-hover', name: 'Whatsapp Background Hover' },
			//search autocomplete
			{
				from: '--neutral-color-low-medium',
				to: '--header-mobile-2-search-autocomplete-text-color',
				name: 'Search Autocomplete Text',
			},
			{
				from: '--neutral-color-low-medium',
				to: '--header-mobile-2-search-autocomplete-text-color',
				name: 'Search Autocomplete Text',
			},
			//--header-mobile-2-topbar-bg-color
			{ from: '--support-color-3', to: '--header-mobile-2-topbar-bg-color', name: 'Topbar Background' },
			//--header-mobile-2-topbar-color
			{ from: '--white', to: '--header-mobile-2-topbar-color', name: 'Topbar Text' },
			//--mz-header-2-mobile-topbar-slider-arrow-color
			{ from: '--white', to: '--header-mobile-2-topbar-slider-arrow-color', name: 'Topbar Slider Arrow' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--header-mobile-2-icons-fs', name: 'Icons text' },
			{ from: '--font-size-xs', to: '--header-mobile-2-links-h-fs', name: 'Links heading' },
			{ from: '--font-size-xs', to: '--header-mobile-2-links-b-fs', name: 'Links body' },
			{ from: '--font-size-xs', to: '--header-mobile-2-search-fs', name: 'SearchBar' },
			{ from: '--font-size-xs', to: '--header-mobile-2-close-d-fs', name: 'Close Drawer' },
			//search autocomplete
			{ from: '--font-size-xs', to: '--header-mobile-2-search-autocomplete-fs', name: 'Search Autocomplete' },
			//--header-mobile-2-topbar-fs
			{ from: '--font-size-xs', to: '--header-mobile-2-topbar-fs', name: 'Topbar' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			//whatsapp border radius
			{ from: '--border-radius-sm', to: '--header-mobile-2-whatsapp-br', name: 'Whatsapp' },
			//search autocomplete
			{ from: '--border-radius-sm', to: '--header-mobile-2-search-autocomplete-br', name: 'Search Autocomplete' },
		],
	},
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-hairline', to: '--header-mobile-2-search-bw', name: 'SearchBar' },
			//whatsapp border radius
			{ from: '--border-radius-sm', to: '--header-mobile-2-whatsapp-br', name: 'Whatsapp' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--header-mobile-2-links-h-fw', name: 'Links heading' },
			{ from: '--font-weight-400', to: '--header-mobile-2-links-b-fw', name: 'Links body' },
			{ from: '--font-weight-400', to: '--header-mobile-2-search-fw', name: 'SearchBar' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--header-mobile-2-text-ff', name: 'Text' }, //ff is font family
			{ from: '--main-font', to: '--header-mobile-2-search-ff', name: 'Search' }, //ff is font family
			//--header-mobile-2-topbar-ff
			{ from: '--main-font', to: '--header-mobile-2-topbar-ff', name: 'Topbar' },
		],
	},
];

export default HeaderMobile;
